module.exports = __webpack_public_path__ + "assets/TrapezoidCut.95888969473243af0e899fe368e33593.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/TrapezoidCut.gmt
// module id = 1024
// module chunks = 0